<template>
  <div class='hero-content'>
    <div class='center-align'>
      <img src='/acps-logo.png' style='width: 150px;' class='logo'/>
    </div>
    <h1 class='center-align header-font' style='margin-top: 1%'> Technology Resources Library </h1>
    
     <div class='center-align' style='margin-top: 3%;'>
     <!--  <a href='https://forms.gle/oQgyJyxdh49R2ghS7' target='_blank'>
        <button class='btn blue white-text'> Provide Feedback </button>
        </a> -->
		<a href='https://apps.powerapps.com/play/e/default-883957d5-03cb-411a-a6cb-d272a5ad80c6/a/c3be0b26-dce8-4fca-be2f-e9fccda0e1a7?tenantId=883957d5-03cb-411a-a6cb-d272a5ad80c6&hint=0a1ee7e7-d63f-4855-b949-8f683aa26e7b&sourcetime=1785763211024' target='_blank'>
        <button class='btn blue white-text'> REQUEST NEW RESOURCE </button>
        </a> 
      </div>
  </div>
</template>

<script>
export default {
  name: 'Header'
  // mounted: function () {
  //   window.onscroll = function () {
  //     var nav = document.getElementById("nav")
  //     var logo = document.getElementById("logo")
  //     if(document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
  //       nav.style.padding = '0px'
  //     }
  //     else {
  //       nav.style.padding = '15px'
  //     }
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
